var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"logo p-1",on:{"click":_vm.homepage}},[_vm._v("BLOCKR")])
}
var staticRenderFns = []

export { render, staticRenderFns }